import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import mutation from "@/v2-backoffice-client/license/seats/license.seats.limitRemove.mutation.gql"
import type {
  LicenseSeatLimitRemoveMutation,
  LicenseSeatLimitRemoveMutationVariables,
} from "@/v2-backoffice-client/license/seats/__types__/license.seats.limitRemove.mutation"

type Options = MutationHookOptions<
  LicenseSeatLimitRemoveMutation,
  LicenseSeatLimitRemoveMutationVariables
>

export function useLicenseSeatLimitRemoveMutation(options?: Options) {
  return useMutation<
    LicenseSeatLimitRemoveMutation,
    LicenseSeatLimitRemoveMutationVariables
  >(mutation, options)
}
